import { Writable, writable } from "svelte/store";

export type RetailerUserAuthenticationModalAttributes = {
  open: boolean;
  distributorId?: number | null;
};

const RetailerUserAuthenticationModalStore: Writable<RetailerUserAuthenticationModalAttributes> =
  writable({ open: false, distributorId: null });

export default RetailerUserAuthenticationModalStore;
